import { render, staticRenderFns } from "./General.vue?vue&type=template&id=8589eda4&scoped=true&"
import script from "./General.js?vue&type=script&lang=js&"
export * from "./General.js?vue&type=script&lang=js&"
import style0 from "./General.sass?vue&type=style&index=0&id=8589eda4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8589eda4",
  null
  
)

export default component.exports